import { Settings } from '../Settings';
import { $window, $body } from '../Constants';
import HtmlElement from './HtmlElement';


/**
 * QuickSearch
 */
const QuickSearch = (($) => {
	// Constants
	const DATA_KEY = 'ig.quicksearch';
	const EVENT_KEY = `.${DATA_KEY}`;

	/**
	 * Selector
	 */
	const Selector = {
		QUICK_SEARCH: '#header .tx-indexedsearch-searchbox',
		OVERLAY: '.tx-indexedsearch-form-wrap',
		TOGGLE: '.toggle-quicksearch',
		CLOSE: '.tx-indexedsearch-form-close'
	};

	/**
	 * Event
	 */
	const Event = {
		RESIZE: `resize${EVENT_KEY}`,
		SCROLL: `scroll${EVENT_KEY}`
	};

	/**
	 * QuickSearch
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class QuickSearch extends HtmlElement {
		/**
		 * @constructor
		 *
		 * @param { jQuery } $element
		 */
		constructor($element) {
			super($element);

			this._$overlay = null;
			this._$toggle = null;
			this._$close = null;
			this._isOpened = false;
		}

		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this._$overlay = this.$element.find(Selector.OVERLAY);
			this._$toggle = this.$element.find(Selector.TOGGLE);
			this._$close = this.$element.find(Selector.CLOSE);

			this._bindHandlers();
		}

		// Private

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			this._$toggle.on('click', (e) => {
				e.preventDefault();
				this._toggle();
			});

			this._$close.on('click', (e) => {
				e.preventDefault();
				this._close();
			});
		}

		_open() {
			this._isOpened = true;
			this._$overlay.addClass('visible');
		}

		_close() {
			this._$overlay.removeClass('visible');
			this._isOpened = false;
		}

		_toggle() {
			this._$overlay.toggleClass('visible', !this._isOpened);
		}
	}

	return QuickSearch._getElement($body.find(Selector.QUICK_SEARCH), QuickSearch);
})();

export default QuickSearch;
